module.exports = __webpack_public_path__ + "img/app-qysq.6c832bb1.webp";